export default "__VITE_PUBLIC_ASSET__8fc86ab2__"